export default __webpack_public_path__ + "static/media/closet5-before2-2048w.085d1dca.avif";